module.exports = __webpack_public_path__ + "img/banner_5.deec1d9a.jpg";